import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const NabidkaTisk = lazy(() =>
  import('@/modules/ojeta-vozidla/NabidkaTisk').then((m) => ({ default: m.NabidkaTisk })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/ojeta-vozidla/nabidky/$id/tisk',
  component: () => (
    <Suspense fallback={null}>
      <NabidkaTisk />
    </Suspense>
  ),
});
